import React from 'react'

import TableData from './tableData'
import TableResultHead from './head'
import Table, { IData } from 'components/layout/table'
import { ITableHead, Head } from 'components/layout/table/head'

export interface IResultTableConfig {
  head: ITableHead[]
  isAggregation?: boolean
  big?: boolean
}

interface IProps {
  config: IResultTableConfig
  data: IData[]
}

class TableResult extends Table<IProps, {}> {
  public render() {
    const { data } = this.props
    const { head, isAggregation, big } = this.props.config

    const tableData = (
      <div className="w-full">
        {data.map((elem: IData, index) => {
          return (
            <div
              key={index}
              className={`${isAggregation &&
                'bg-gray-100'} px-48 flex py-10 border-t-1 border-gray-200 first-child:border-t-0`}
            >
              {head.map((headItem: ITableHead) => {
                return (
                  <TableData
                    key={headItem.key}
                    name={headItem.key}
                    col={headItem.col}
                    text={this.getValue(elem, headItem.key)}
                    highlight={Head.prototype.isHighlight(headItem)}
                    big={big}
                    leftAlign={headItem.leftAlign}
                    unit={this.getUnit(elem, headItem.key) || this.getHeadUnit(headItem)}
                  />
                )
              })}
            </div>
          )
        })}
      </div>
    )

    return (
      <>
        <TableResultHead head={head} />
        {tableData}
      </>
    )
  }
}

export default TableResult
